import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { portfolioData } from '../data/mock';

const AISection = () => {
  const { hobbies } = portfolioData;
  const { ai } = hobbies;
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => setIsVisible(entry.isIntersecting), { threshold: 0.3 });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  
  const nodes = Array.from({ length: 15 }, (_, i) => ({ id: i, x: 10 + Math.random() * 80, y: 10 + Math.random() * 80 }));
  
  return (
    <section ref={sectionRef} className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 md:px-12 lg:px-24 relative">
      {isVisible && (
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <svg className="w-full h-full opacity-40">
            {nodes.map((node, i) => nodes.slice(i + 1).map((other, j) => {
              const dist = Math.sqrt(Math.pow(node.x - other.x, 2) + Math.pow(node.y - other.y, 2));
              if (dist < 30) {
                return (
                  <motion.line key={`${i}-${j}`} x1={`${node.x}%`} y1={`${node.y}%`} x2={`${other.x}%`} y2={`${other.y}%`} stroke="rgba(180, 195, 220, 0.08)" strokeWidth="1"
                    initial={{ opacity: 0 }} animate={{ opacity: [0.05, 0.15, 0.05] }} transition={{ duration: 3, repeat: Infinity, delay: Math.random() * 2 }} />
                );
              }
              return null;
            }))}
            {nodes.map((node, i) => (
              <motion.circle key={i} cx={`${node.x}%`} cy={`${node.y}%`} r={3 + Math.random() * 3} fill="rgba(180, 200, 230, 0.4)"
                initial={{ opacity: 0.3 }} animate={{ opacity: [0.3, 0.8, 0.3], scale: [1, 1.2, 1] }} transition={{ duration: 2 + Math.random() * 2, repeat: Infinity, delay: Math.random() * 2 }} />
            ))}
          </svg>
        </div>
      )}
      
      <div className="max-w-4xl mx-auto relative z-10">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="text-center mb-2">
          <h2 className="text-2xl sm:text-3xl md:text-4xl" style={{ fontFamily: 'Cinzel, serif', color: 'rgba(235, 240, 250, 0.95)', fontWeight: 400 }}>{ai.heading}</h2>
        </motion.div>
        
        <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.1 }} className="text-center mb-8 sm:mb-10 md:mb-12" style={{ fontFamily: 'DM Mono, monospace', color: 'rgba(150, 170, 200, 0.7)', fontSize: '0.85rem' }}>
          {ai.subtitle}
        </motion.p>
        
        <motion.div 
          initial={{ opacity: 0, y: 30 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          viewport={{ once: true }} 
          transition={{ duration: 0.8 }}
          whileHover={{ scale: 1.01, y: -2 }}
          className="glass-panel p-6 sm:p-8 md:p-10"
        >
          {ai.content.split('\n\n').map((para, i) => (
            <p key={i} className="mb-3 sm:mb-4 last:mb-0 text-sm sm:text-base" style={{ fontFamily: 'EB Garamond, serif', color: 'rgba(220, 230, 245, 0.9)', lineHeight: '1.85' }}>{para}</p>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default AISection;